module.exports = __webpack_public_path__ + "8d79240144858d030123fb5ccc2d24bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/vipPay_inactive.png
// module id = 578
// module chunks = 0